export default {
  mStartKYC(state) {
    state.kycID = new Date().toLocaleString();
  },
}
